import { Box, Backdrop, CircularProgress, Button, Stack, Typography, TextField, useTheme, useMediaQuery, MenuItem, List, ListItem } from "@mui/material";
import { useState, useContext, useEffect, useMemo } from "react";
import { Scanner } from '@yudiel/react-qr-scanner';
import { Context } from "../App";
import { API } from "../conf";
import Header from "./Header";

export default function QRScan() {
    const {updateConnect} = useContext(Context)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const [load, setLoad] = useState(false)
    const [scan, setScan] = useState(false)
    const [delegues, setDelegues] = useState([])
    const [msg, setMsg] = useState('')


    function handleScan(data){
        setLoad(true); setMsg('')
        const result = data.map(d=>decodeURIComponent(d.rawValue));
        if (!delegues.includes(result)) {
            fetch(API.concat(`/vote/update`), {method:'PATCH', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json'},
                body:JSON.stringify({delegues:[...new Set([...delegues, ...result])]})
            }).then(async response =>{
                if(response.status !== 200) {
                    setMsg('Donnée non synchronisée. Vérifiez votre connexion')
                }
                setDelegues(old=>[...new Set([...old, ...result])])
                setLoad(false)
            })
        } else {
            setLoad(false)   
        }
    }

    return(
        <div>
            <Header/>
            <Box display='flex' flexDirection='column' sx={{flex:1, marginY:'20px', marginX:3}}>
                <Typography variant={isMobile?"h4":"h3"} align="center">AGO {new Date().getFullYear()}</Typography>
                <Typography variant="h5" align="center">Scanner</Typography>
                {!scan&&<Button variant="contained" sx={{alignSelf:'center', marginTop:'100px'}} onClick={()=> setScan(true)}>Scanner</Button>}
                {scan&&<Button variant="contained" sx={{alignSelf:'center', marginTop:'30px', marginBottom:'20px'}} onClick={()=> {setScan(false);setDelegues([]);setMsg('')}}>Arrêter</Button>}
                {scan&&<Scanner styles={{container:{width:'300px', height:'300px', alignSelf:'center', marginBottom:'30px'}}} scanDelay={500} onScan={handleScan} />}
                {msg!==''&&<Typography variant="h6" align="center" color="error">{msg}</Typography>}
                <Typography>Scannés:</Typography>
                <List>
                    {delegues && delegues.map((delegue, index)=><ListItem key={index}>{delegue}</ListItem>)}
                </List>
                <Backdrop open={load}><CircularProgress color="inherit" /></Backdrop>
            </Box>
        </div>
    )
}